var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.662 47.5C12.067 47.5 1.8999 37.2571 1.8999 24.7379C1.8999 12.2188 12.1428 1.89999 24.662 1.89999C29.8214 1.89999 34.7531 3.56921 38.7744 6.83177C39.7608 7.59051 39.9125 9.03211 39.1538 10.0185C38.3951 11.0048 36.9535 11.1566 35.9671 10.3978C32.7046 7.81813 28.835 6.45241 24.662 6.45241C14.6467 6.45241 6.45231 14.6467 6.45231 24.6621C6.45231 34.6774 14.6467 42.8717 24.662 42.8717C34.6773 42.8717 42.8716 34.6774 42.8716 24.6621C42.8716 23.3722 42.7199 22.0824 42.4922 20.8684C42.2646 19.6544 43.0234 18.4404 44.2373 18.1369C45.4513 17.9093 46.6653 18.668 46.9688 19.882C47.2723 21.3995 47.424 22.9928 47.424 24.5862C47.4999 37.2571 37.257 47.5 24.662 47.5Z",
    fill: "#189F1D",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7378 33.9944C24.1309 33.9944 23.5239 33.7668 23.1445 33.3116L12.5981 22.6134C11.6876 21.7029 11.7635 20.2613 12.5981 19.4267C13.5086 18.5162 14.9502 18.5921 15.7848 19.4267L24.7378 28.4557L43.6304 9.33553C44.5408 8.42504 45.9824 8.42504 46.817 9.33553C47.7275 10.246 47.7275 11.6876 46.817 12.5222L26.3312 33.2357C25.8759 33.6909 25.3448 33.9944 24.7378 33.9944Z",
    fill: "#189F1D",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6,
    height: 45.6,
    fill: "white",
    transform: "translate(1.8999 1.89999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.9ffb404cc22f68f184f53905e1b1c646.svg";
export { ForwardRef as ReactComponent };